export var InputValue; (function (InputValue) {
  const UNTOUCHED = 'UNTOUCHED-INPUT-VALUE'; InputValue["UNTOUCHED"] = UNTOUCHED;
})(InputValue || (InputValue = {}));

// Configure your proxy target on app-config.yaml or
// app-config.[production | development].yaml file under proxy field
// example below:
//  proxy:
//    '/test':
//       target: 'https://example.com'
export var PROXY_TARGETS; (function (PROXY_TARGETS) {
  const BACKEND = 'apidev'; PROXY_TARGETS["BACKEND"] = BACKEND;
  const JIRA = 'jira'; PROXY_TARGETS["JIRA"] = JIRA;
  const OPSGENIE = 'opsgenie'; PROXY_TARGETS["OPSGENIE"] = OPSGENIE;
  const STATUSPAGE = 'statuspage'; PROXY_TARGETS["STATUSPAGE"] = STATUSPAGE;
})(PROXY_TARGETS || (PROXY_TARGETS = {}));
